/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerListToolCallsQueryResponse, IncidentInvestigationControllerListToolCallsPathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerListToolCalls";

function getIncidentInvestigationControllerListToolCallsUrl(id: IncidentInvestigationControllerListToolCallsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/incident-agent/investigations/${id}/tool-calls` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/tool-calls}
 */
export async function incidentInvestigationControllerListToolCalls(id: IncidentInvestigationControllerListToolCallsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerListToolCallsQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getIncidentInvestigationControllerListToolCallsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}